import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import { Button } from '~/ui/core/button/Button';

import { ErrorPage } from '../../design/components/errors/ErrorPage';

export const Error400: FunctionComponent = () => {
    const { actions, translate } = useContext(ApplicationContext);

    return (
        <ErrorPage
            errorCode={400}
            message={translate('errors.status.400.message')}
            title={translate('errors.status.400.title')}
        >
            <Button variant="primary" onClick={() => actions.navigateTo('/dashboard')}>
                {translate('errors.status.400.action')}
            </Button>
        </ErrorPage>
    );
};

export const Error403: FunctionComponent = () => {
    const { actions, translate } = useContext(ApplicationContext);

    return (
        <ErrorPage
            errorCode={403}
            message={translate('errors.status.403.message')}
            title={translate('errors.status.403.title')}
        >
            <Button variant="primary" onClick={() => actions.navigateTo('/dashboard')}>
                {translate('errors.status.403.action')}
            </Button>
        </ErrorPage>
    );
};

export const Error404: FunctionComponent = () => {
    const { actions, translate } = useContext(ApplicationContext);

    return (
        <ErrorPage
            errorCode={404}
            message={translate('errors.status.404.message')}
            title={translate('errors.status.404.title')}
        >
            <Button variant="primary" onClick={() => actions.navigateTo('/dashboard')}>
                {translate('errors.status.404.action')}
            </Button>
        </ErrorPage>
    );
};

export const Error500: FunctionComponent = () => {
    const { translate } = useContext(ApplicationContext);

    return (
        <ErrorPage
            errorCode={500}
            message={translate('errors.status.500.message')}
            title={translate('errors.status.500.title')}
        >
            <Button variant="primary" onClick={() => globalThis.location.reload()}>
                {translate('errors.status.500.action')}
            </Button>
        </ErrorPage>
    );
};
